export function displayNotificationCount(count?: number): string {
    if (count === undefined) {
        return '';
    }

    return count > 99 ? '99+' : count.toString();
}
